<template>
  <div class="the-navbar__user-meta flex items-center">
    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ storeProfileData.displayName }}</p>
      <small>@{{ storeProfileData.nickName }}</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <vs-avatar :text="storeProfileData.displayName" size="40px" :src="storeProfileData.avatar"></vs-avatar>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <div @click="$router.push({name: 'profile-settings'})">
              <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">{{ $t('menus.profileDropDown.profile') }}</span>
            </div>
          </li>

<!--          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">-->
<!--            <feather-icon icon="MailIcon" svgClasses="w-4 h-4" />-->
<!--            <span class="ml-2">Inbox</span>-->
<!--          </li>-->

<!--          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">-->
<!--            <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />-->
<!--            <span class="ml-2">Tasks</span>-->
<!--          </li>-->

<!--          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">-->
<!--            <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />-->
<!--            <span class="ml-2">Chat</span>-->
<!--          </li>-->

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="BellIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{ $t('menus.profileDropDown.notifications') }}</span>
          </li>

          <vs-divider class="m-1" />

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{ $t('menus.profileDropDown.logout') }}</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  computed: {
    storeProfileData() {
      const profileGeneral = this.$store.getters['Profile/profileData'].dataGeneral;
      return profileGeneral;
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('Auth/logout').then(() => {
        this.$acl.change(['public']);
        this.$router.push({ name: 'login' });
      });
    },
  }
}
</script>
